import { render, staticRenderFns } from "./VueTurnstile.vue?vue&type=template&id=0286b464"
import script from "./VueTurnstile.vue?vue&type=script&lang=js"
export * from "./VueTurnstile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports